import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { MdEmail } from "react-icons/md";import { IoMdCall } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FaPaperPlane } from "react-icons/fa";
import QueryForm from '../Home/QueryForm';



const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState({});
  const [hideTopBar, setHideTopBar] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHideTopBar(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Toggle submenu: open/close independently
  const toggleSubmenu = (key) => {
    setSubmenuOpen(prev => ({
      ...prev,
      [key]: !prev[key]  // toggle this submenu only
    }));
  };

  // Close mobile menu completely when a link is clicked
  const handleLinkClick = () => {
    setMenuOpen(false);
    setSubmenuOpen({}); // close all submenus
  };

  return (
    <header className="navbar-header">
      {/* ================= Desktop Navbar ================= */}
      <div className="navbar-desktop">
        {/* Top bar */}
        <div className="navbar-top-bar">
          {/* Logo */}
          <Link to="/">
          <div className="navbar-logo">
            <span><img src="./Images/logo/cab.png" alt="Logo" /></span>
          </div>
          </Link>

          {/* Contact */}
            <div className="navbar-contact">
              <div className="navbar-contact-item">
                <MdEmail className="contact-icon" />
                <div className="contact-text">
                  <span className="contact-label">Quick Questions? Email Us</span>
                  <span className="contact-info"> booking@hyderabadtoursandtravels.com</span>
                </div>
              </div>

              <div className="navbar-contact-item">
                <IoMdCall className="contact-icon" />
                <div className="contact-text">
                  <span className="contact-label">Talk to an Expert</span>
                  <span className="contact-info">+91-9701238500</span>
                </div>
              </div>

            <button
              className="navbar-contact-btn"
              onClick={() => setShowModal(true)}
            >
              <FaPaperPlane style={{ marginRight: "8px" }} />
              Send a Query
            </button>
            </div>

        </div>

        {/* Desktop Nav */}
  <nav className="navbar-main">
    <ul className="navbar-links">
      <li><a href="/">Home</a></li>

      {/* Tourist Vehicles with icons */}
      <li className="navbar-dropdown">
        <div className='navbar-dropdownIcon'>
          <span className='dropdown-label'>
            Tourist Vehicles <RiArrowDropDownLine className='dropdown-arrow' />
          </span>
        </div>
        <div className="mega-dropdown modern">
          <div className="mega-column">
            <h4>Tempo Traveller</h4>
            <Link to="/tourist-vehicles/9-seater">9 Seater</Link>
            <Link to="/tourist-vehicles/12-seater">12 Seater</Link>
            <Link to="/tourist-vehicles/16-seater">16 Seater</Link>
          </div>
            <div className="mega-column">
            <h4>Bus Rental</h4>
            <Link to="/tourist-vehicles/20-seater-bus">20 Seater</Link>
            <Link to="/tourist-vehicles/30-seater-bus">30 Seater</Link>
            <Link to="/tourist-vehicles/40-seater-bus">40 Seater</Link>
          </div>
            <div className="mega-column">
            <h4>Car Rental</h4>
            <Link to="/tourist-vehicles/maruti-ertiga">Maruti Ertiga</Link>
            <Link to="/tourist-vehicles/toyota-innova">Toyota Innova</Link>
            <Link to="/tourist-vehicles/innova-hycross">Innova Hycross</Link>
            <Link to="/tourist-vehicles/swift-dzire">Swift Dzire</Link>
          </div>
        </div>
      </li>

        {/* Outstation Trip */}
        <li className="navbar-dropdown">
          <div className='navbar-dropdownIcon'>
            <span className='dropdown-label'>
              Outstation Trip <RiArrowDropDownLine className='dropdown-arrow' />
            </span>
          </div>
          <div className="mega-dropdown modern wide">
            <div className="mega-column">
              <h4>Weekend Trips</h4>
              <a href="/outstation/ramoji-film-city">Hyderabad to Ramoji Film City</a>
              <a href="/outstation/charminar">Hyderabad to Charminar</a>
              <a href="/outstation/golconda-fort">Hyderabad to Golconda Fort</a>
            </div>
            <div className="mega-column">
              <h4>Long Trips</h4>
              <a href="/outstation/warangal">Hyderabad to Warangal</a>
              <a href="/outstation/nagarjuna-sagar">Hyderabad to Nagarjuna Sagar</a>
              <a href="/outstation/vijayawada">Hyderabad to Vijayawada</a>
              <a href="/outstation/goa">Hyderabad to Goa</a>
            </div>
          </div>
        </li>

        {/* Tour Packages */}
        <li className="navbar-dropdown">
          <div className='navbar-dropdownIcon'>
            <Link to="/tour-packages" className='dropdown-label'>
              Tour Packages <RiArrowDropDownLine className='dropdown-arrow' />
            </Link>
          </div>
          <div className="mega-dropdown modern wide">
            <div className="mega-column">
              <h4>City Tours</h4>
              <Link to="/tour-packages/hyderabad-sightseeing-tour-package">Hyderabad Sightseeing Tour Package</Link>
              <Link to="/tour-packages/hyderabad-to-goa-tour-package">Hyderabad to Goa Tour Package</Link>
            </div>
            <div className="mega-column">
              <h4>Heritage Tours</h4>
              <Link to="/tour-packages/hyderabad-to-hampi-tour-package">Hyderabad to Hampi Tour Package</Link>
              <Link to="/tour-packages/srisailam-temple-tour-package">Srisailam Temple Tour Package</Link>
            </div>
            <div className="mega-column">
              <h4>Special Packages</h4>
              <Link to="/tour-packages/warangal-heritage-tour-package">Warangal Heritage Tour Package</Link>
              <Link to="/tour-packages/hyderabad-to-vijayawada-tour-package">Hyderabad to Vijayawada Tour Package</Link>
            </div>
          </div>
        </li>


      <li><a href="/blogs">Blog</a></li>
      <li><a href="/contact-us">Contact Us</a></li>
    </ul>
  </nav>

      </div>

      {/* ================= Mobile Navbar ================= */}
        <div className="navbar-mobile">
                <div className="navbar-top-bar">
                  <div className="navbar-logo">
                    <span><img src="/Images/logo/cab.png" alt="Logo" /></span>
                  </div>
                  <div
                    className={`navbar-hamburger ${menuOpen ? 'open' : ''}`}
                    onClick={() => setMenuOpen(true)}
                  >
                   <span><GiHamburgerMenu /></span>
                  </div>
                </div>

                {/* Mobile Sidebar */}
                <div className={`mobile-menu ${menuOpen ? 'active' : ''}`} id="mobileMenu">
                  <div className="mobile-menu-header">
                    <div className="mobile-menu-logo">
                      <img src="/Images/logo/cab.png" alt="Logo" />
                    </div>
                    <div className="mobile-menu-close" onClick={() => setMenuOpen(false)}><RxCross2 /></div>
                  </div>

                  <ul className="mobile-menu-links">
                    <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>

                    {/* Tourist Vehicle */}
                    <li className={submenuOpen["tourist"] ? "has-submenu open" : "has-submenu"}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("tourist"); }}>
                        Tourist Vehicle <IoIosArrowDropdownCircle className="arrow"/>
                      </a>
                      <ul className="submenu">
                        {/* Tempo Traveller */}
                        <li className={submenuOpen["tempo"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("tempo"); }}>
                            Tempo Traveller <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tourist-vehicles/9-seater" onClick={handleLinkClick}>9 Seater</Link></li>
                            <li><Link to="/tourist-vehicles/12-seater" onClick={handleLinkClick}>12 Seater</Link></li>
                            <li><Link to="/tourist-vehicles/16-seater" onClick={handleLinkClick}>16 Seater</Link></li>
                          </ul>
                        </li>

                        {/* Bus Rental */}
                        <li className={submenuOpen["bus"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("bus"); }}>
                            Bus Rental <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tourist-vehicles/20-seater-bus" onClick={handleLinkClick}>20 Seater</Link></li>
                            <li><Link to="/tourist-vehicles/30-seater-bus" onClick={handleLinkClick}>30 Seater</Link></li>
                            <li><Link to="/tourist-vehicles/40-seater-bus" onClick={handleLinkClick}>40 Seater</Link></li>
                          </ul>
                        </li>

                        {/* Car Rental */}
                        <li className={submenuOpen["car"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("car"); }}>
                            Car Rental <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tourist-vehicles/maruti-ertiga" onClick={handleLinkClick}>Maruti Ertiga</Link></li>
                            <li><Link to="/tourist-vehicles/toyota-innova" onClick={handleLinkClick}>Toyota Innova</Link></li>
                            <li><Link to="/tourist-vehicles/innova-hycross" onClick={handleLinkClick}>Innova Hycross</Link></li>
                            <li><Link to="/tourist-vehicles/swift-dzire" onClick={handleLinkClick}>Swift Dzire</Link></li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    {/* Outstation Trip */}
                    <li className={submenuOpen["outstation"] ? "has-submenu open" : "has-submenu"}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("outstation"); }}>
                        Outstation Trip <IoIosArrowDropdownCircle className="arrow"/>
                      </a>
                      <ul className="submenu">
                        <li className={submenuOpen["weekend"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("weekend"); }}>
                            Weekend Trips <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/outstation/ramoji-film-city" onClick={handleLinkClick}>Hyderabad to Ramoji Film City</Link></li>
                            <li><Link to="/outstation/charminar" onClick={handleLinkClick}>Hyderabad to Charminar</Link></li>
                            <li><Link to="/outstation/golconda-fort" onClick={handleLinkClick}>Hyderabad to Golconda Fort</Link></li>
                          </ul>
                        </li>

                        <li className={submenuOpen["long"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("long"); }}>
                            Long Trips <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/outstation/warangal" onClick={handleLinkClick}>Hyderabad to Warangal</Link></li>
                            <li><Link to="/outstation/nagarjuna-sagar" onClick={handleLinkClick}>Hyderabad to Nagarjuna Sagar</Link></li>
                            <li><Link to="/outstation/vijayawada" onClick={handleLinkClick}>Hyderabad to Vijayawada</Link></li>
                            <li><Link to="/outstation/goa" onClick={handleLinkClick}>Hyderabad to Goa</Link></li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    {/* Tour Packages */}
                    <li className={submenuOpen["packages"] ? "has-submenu open" : "has-submenu"}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("packages"); }}>
                        Tour Packages <IoIosArrowDropdownCircle className="arrow"/>
                      </a>
                      <ul className="submenu">
                        <li className={submenuOpen["city"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("city"); }}>
                            City Tours <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tour-packages/hyderabad-sightseeing-tour-package" onClick={handleLinkClick}>Hyderabad Sightseeing Tour Package</Link></li>
                            <li><Link to="/tour-packages/hyderabad-to-goa-tour-package" onClick={handleLinkClick}>Hyderabad to Goa Tour Package</Link></li>
                          </ul>
                        </li>

                        <li className={submenuOpen["heritage"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("heritage"); }}>
                            Heritage Tours <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tour-packages/hyderabad-to-hampi-tour-package" onClick={handleLinkClick}>Hyderabad to Hampi Tour Package</Link></li>
                            <li><Link to="/tour-packages/srisailam-temple-tour-package" onClick={handleLinkClick}>Srisailam Temple Tour Package</Link></li>
                          </ul>
                        </li>

                        <li className={submenuOpen["special"] ? "has-submenu open" : "has-submenu"}>
                          <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("special"); }}>
                            Special Packages <IoIosArrowDropdownCircle className="arrow"/>
                          </a>
                          <ul className="submenu">
                            <li><Link to="/tour-packages/warangal-heritage-tour-package" onClick={handleLinkClick}>Warangal Heritage Tour Package</Link></li>
                            <li><Link to="/tour-packages/hyderabad-to-vijayawada-tour-package" onClick={handleLinkClick}>Hyderabad to Vijayawada Tour Package</Link></li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    <li><Link to="/blogs" onClick={handleLinkClick}>Blog</Link></li>
                  </ul>
                </div>
              </div>
{showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div
      className="modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close"
        onClick={() => setShowModal(false)}
      >
        ✖
      </button>

<div className="custom-query-form">
  <h2>Send a Quick Query</h2>
  <p>We’ll get back to you shortly</p>

  <input type="text" placeholder="Your Name" />
  <input type="tel" placeholder="Phone Number" />
  <input type="email" placeholder="Email Address" />
  
  <textarea placeholder="Your Message" rows="4"></textarea>

  <button className="submit-btn">
    Submit Query
  </button>
</div>
    </div>
  </div>
)}

    </header>
  );
};

export default Navbar;
